// extracted by mini-css-extract-plugin
export const container = "CruiseSegmentCard-module--container--3-fUK";
export const active = "CruiseSegmentCard-module--active--30RBk";
export const cruiseName = "CruiseSegmentCard-module--cruise-name--3xTKO";
export const dates = "CruiseSegmentCard-module--dates--37rdK";
export const arrivalDate = "CruiseSegmentCard-module--arrival-date--2OHf7";
export const departureDate = "CruiseSegmentCard-module--departure-date--34Ozn";